export default __webpack_public_path__ + "static/RobotoMono-600italic-213eedde97d22010287cf492a821e563.woff";